import Map from 'ol/map';
import TileLayer from 'ol/layer/tile';
import VectorLayer from 'ol/layer/vector';
import OsmSource from 'ol/source/osm';
import VectorSource from 'ol/source/vector';
import View from 'ol/view';

import config from './defaultConfig';

const createMap = usrConfig => {

    const osmLayer = new TileLayer({
        source: new OsmSource(),
    });

    let usrLayers;

    if (usrConfig.layers) {
        usrLayers = usrConfig.layers.map(usrLayer => usrLayer.create());
    } else {
        usrLayers = [];
    }

    const view = new View(
        config.view(usrConfig)
    );

    const map = new Map({
        target: usrConfig.target,
        layers: [
            osmLayer,
            ...usrLayers,
        ],
        view,
    });

    window.GisMap = map;

    /* obtains URL from feature's properties and moves to it */
    function mapClick(event){
        event.preventDefault();
        event.stopPropagation();

        let features = map.getFeaturesAtPixel(event.pixel);
        if ((features != null) && (features.length > 0)){
            let moveTo = features[0].getProperties()["id"];
            if (moveTo != null){
                let currentlyAt =  window.location.href;
                if (currentlyAt.charAt(currentlyAt.length - 1) === '/'){
                    window.location.href += moveTo;
                } else if (isNaN(parseInt(currentlyAt.charAt(currentlyAt.length - 1) ))) {
                    window.location.href += ('/' + moveTo);
                }
            }
        }
    };

    map.on("singleclick", mapClick);

    return map;
};

export default createMap;



// WEBPACK FOOTER //
// ./resources/assets/js/src/maps/createMap.js